import { Injectable } from '@angular/core'
import { BaseLocalStorageService } from '@engineering11/web-utilities'
import { ViewModes } from '../constants'
import { RequestedUpdateFields } from '../model/candidate-application.model'
import { ICnectUser } from '../model/interfaces'
import { SwimlaneConfig } from '../model/swimlane.model'

export type ResponseOptionType = 'text' | 'video'

export interface ILocalStorage {
  user: ICnectUser
  candidateListSwimlaneConfig: SwimlaneConfig
  jobPostsViewMode: { [jobPostId: string]: ViewModes }
  token: string
  ignoredApplicationRequests: { [jobPostId: string]: RequestedUpdateFields[] }
  selectedResponseOption: { [questionId: string]: ResponseOptionType }
  authToken?: string
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService extends BaseLocalStorageService<ILocalStorage> {
  public getAccessToken(): string | null {
    return this.getItem('token')
  }
}
